<div class="auth-page-wrapper pt-5">
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div class="bg-overlay"></div>

        <div class="shape">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
        </div>
    </div>

    <div class="auth-page-content">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center mt-sm-5 mb-4 text-white-50">
                        <!-- <div>
                            <a href="index.html" class="d-inline-block auth-logo">
                                <img src="assets/images/logo-light.png" alt="" height="20">
                            </a>
                        </div> -->
                        <p class="mt-3 fs-15 fw-medium" style="color: yellow;">Visitor Management System</p>
                        <p class="mt-3 fs-18 fw-bolder" style="color: yellow;">{{appservice.Company_Name}}</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card mt-4 card-bg-fill">

                        <div class="text-center mt-2">
                            <h5 class="text-primary">Please enter your details</h5>
                            <!-- <p class="text-muted">Sign in to continue.</p> -->
                        </div>
                        <div class="card-body p-4">
                            <div class="p-2 mt-4">
                                <form #addForm="ngForm"  novalidate>
                                    <div class="mb-3">
                                        <label for="username" class="form-label"><span class="text-danger">*</span>First Name</label>
                                        <input type="text" class="form-control" name="Visitor_Name" [(ngModel)]="add.Visitor_Name" placeholder="Enter First Name">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Last Name</label>
                                        <input type="text" class="form-control" name="Last_Name" [(ngModel)]="add.Last_Name" placeholder="Enter Last Name">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label"><span class="text-danger">*</span>Company Name</label>
                                        <input type="text" class="form-control" name="Company_Name" [(ngModel)]="add.Company_Name" placeholder="Enter Company Name">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label"><span class="text-danger"></span>Gender</label>
                                        <select class="form-select mb-3" name="Gender" [(ngModel)]="add.Gender" aria-label="Default select example">
                                            <option *ngFor="let k of appservice.get_ref('Gender')"
                                            value={{k.label}}>{{k.label}}</option>
                                        </select>
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label"><span class="text-danger">*</span>Purpose of Visit</label>
                                        <select class="form-select mb-3" name="Purpose" [(ngModel)]="add.Purpose" aria-label="Default select example">
                                            <option *ngFor="let k of appservice.get_ref('Purpose')"
                                            value={{k.label}}>{{k.label}}</option>
                                        </select>
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label"><span class="text-danger">*</span>Meeting Person Mobile Number</label>
                                        <input type="text" class="form-control" name="V_Person_Contact" [(ngModel)]="add.V_Person_Contact" (input)="get_Ph_No($event)" placeholder="Enter Meeting Person Mobile Number">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Meeting Person Name</label>
                                        <input type="text" class="form-control" name="V_Person" [(ngModel)]="add.V_Person" placeholder="Enter Meeting Person Name">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Department</label>
                                        <select class="form-select mb-3" name="V_Department" [(ngModel)]="add.V_Department" aria-label="Default select example">
                                            <option *ngFor="let k of appservice.get_ref('Department')"
                                            value={{k.label}}>{{k.label}}</option>
                                        </select>
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Tag No</label>
                                        <input type="text" class="form-control" name="Tag_No" [(ngModel)]="add.Tag_No" placeholder="Enter Tag No">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Laptop</label>
                                        <select class="form-select mb-3" name="Laptop_Permit" [(ngModel)]="add.Laptop_Permit" aria-label="Default select example">
                                            <option *ngFor="let k of appservice.get_ref('Yes_No')"
                                            value={{k.label}}>{{k.label}}</option>
                                        </select>
                                    </div>
                                    <div class="mb-3" *ngIf="(add.Laptop_Permit=='Yes')">
                                        <label for="username" class="form-label"><span class="text-danger">*</span>Serial No</label>
                                        <input type="text" class="form-control" name="Serial_No" [(ngModel)]="add.Serial_No" placeholder="Enter Serial No">
                                    </div>

                                    <div class="mb-3">
                                        <label for="username" class="form-label">Remarks</label>
                                        <input type="text" class="form-control" name="Remarks" [(ngModel)]="add.Remarks" placeholder="Enter Remarks">
                                    </div>
                                    <div class="mt-4">
                                        <button class="btn btn-success w-100" (click)="addData()" [disabled]="btndisable"  type="button">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>